import { bindable } from 'aurelia-framework';
import { IImportPreviewRowAM } from './import-api';

export class ImportPreview {
	@bindable rows: IImportPreviewRowAM[];
	@bindable importType: string;
	@bindable dimensionValueHeaders: string[];
}
